import { FaFacebookMessenger, FaViber, FaTelegramPlane, FaVk, FaWhatsapp, FaInstagram, FaSkype } from 'react-icons/fa';

export const MESSENGERS_REACT_ICONS_MAP = {
    messenger: FaFacebookMessenger,
    viber: FaViber,
    telegram: FaTelegramPlane,
    vk: FaVk,
    whatsapp: FaWhatsapp,
    instagram: FaInstagram,
    skype: FaSkype,
};

export const MESSENGERS = {
    whatsapp: {
        label: 'WhatsApp',
        color: '#4FCE5D',
    },
    telegram: {
        label: 'Telegram',
        color: '#0088CC',
    },
    viber: {
        label: 'Viber',
        color: '#675CA8',
    },
    messenger: {
        label: 'Facebook messenger',
        color: '#0084FF',
    },
    vk: {
        label: 'Vkontakte',
        color: '#597BA0',
    },
    skype: {
        label: 'Skype',
        color: '#00AFF0',
    },
    line: {
        label: 'Line',
        color: '#00AFF0',
    },
    instagram: {
        label: 'Instagram Direct',
        color: '#E1306C',
    },
};
